import React from "react";
import CommonRow from "../common-row";

const OneColThreeStoriesSlider = props => {
  return <CommonRow {...props} />;
};

export default OneColThreeStoriesSlider;
